import React, { useMemo } from 'react';

const TipsWaiterTeamPhoto = ({ employees, small }) => {
  if (!employees || employees.length === 0) {
    return null;
  }

  const employeeImages = useMemo(() => {
    const images = [];

    employees.forEach((employee) => {
      if (images.length === 3) {
        return;
      }

      if (employee.image) {
        images.push(employee.image);
      }
    });

    return images;
  }, [employees]);

  if (!employeeImages || employeeImages.length === 0) {
    return null;
  }

  const renderImage = (imageLink, ind) => {
    return (
      <div
        key={`${ind}`}
        className={`rounded-full w-full h-auto
        overflow-hidden border bg-white border-white
        relative`}
        style={{
          zIndex: employeeImages.length - ind,
          left: `-${ind * (small ? 0.85 : 1.25)}rem`,
          maxWidth: small ? '2.3rem' : '3.2rem',
          maxHeight: small ? '2.3rem' : '3.2rem',
        }}
      >
        <img src={imageLink} alt="" className="rounded-full w-full h-full" />
      </div>
    );
  };

  return (
    <div
      className="flex flex-row relative"
      style={{ marginRight: `-${(employeeImages.length - 1) * (small ? 0.85 : 1.25)}rem` }}
    >
      {employeeImages.map((x, ind) => renderImage(x, ind))}
    </div>
  );
};

export default TipsWaiterTeamPhoto;
